import { Typography } from 'antd';
import { TitleProps } from 'antd/es/typography/Title';
import styled from 'styled-components';
import { APP_SHELL_THEME } from '@/styles/appShellTheme';

const { Title } = Typography;

const getFontWeight = (level: TitleProps['level']): number => {
  switch (level) {
    case 1:
      return 600;
    case 2:
      return 600;
    case 3:
      return 500;
    case 4:
      return 600;
    default:
      return 500;
  }
};

export const StyledTitle = styled(Title)<TitleProps>`
  &.ant-typography {
    color: rgba(${APP_SHELL_THEME.overlayRgb}, 0.92);
    font-weight: ${({ level }) => getFontWeight(level)};
    margin-top: 0;
    margin-bottom: 0;
  }

  &.ant-typography-secondary {
    color: ${APP_SHELL_THEME.textMuted};
  }
`;
